import React from 'react';

interface HelpButtonProps {
  className?: string;
  variant?: string;
  size?: "sm" | "lg";
  title?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({ 
  className = "", 
  variant = "primary",
  size,
  title = "Chat"
}) => {
  const handleClick = () => {
    if ((window as any).openZendesk) {
      (window as any).openZendesk();
    } else {
      console.warn('Zendesk is not available');
    }
  };

  return (
    <span
      className={className}
      title={title}
      style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', }}
      onClick={handleClick}
    >
      <i className="fa fa-comment" style={{ marginRight: 6 }}></i>Chat
    </span>
  );
};

export default HelpButton;